import { Component } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';
import { ConfigService } from '../../../services/config.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'form-checkbox',
  templateUrl: './form-checkbox.component.html',
  styleUrls: ['./form-checkbox.component.css']
})
export class FormCheckboxComponent {
  config;
  group: FormGroup;

  constructor(private configService: ConfigService) { }

  get choicesArray() {
    return <FormArray>this.group.get(this.config.name);
  }

  getSelectedCheckboxValues() {
    this.configService.getSelectedCheckboxValues(this.group, this.config);
  }

}
